import { useTheme } from "@mui/material";
import { HImage } from "@ob/core";
import { useMobileBreakpoint } from "@ob/theme";
import { FC } from "react";

export type LogoProps = {
  width?: number;
  height?: number;
  isFooter?: boolean;
  customLogo?: { url: string; width: string; height: string };
};

export const Logo: FC<LogoProps> = ({
  height,
  width,
  isFooter,
  customLogo,
}) => {
  const theme = useTheme();
  const { logoHeader, logoFooter } = theme?.contents ?? {};
  let logo = isFooter ? logoFooter : logoHeader;
  if (customLogo) {
    logo = customLogo;
  }
  const { isMobile } = useMobileBreakpoint();
  const w = width ?? isMobile ? 38 : 58;
  const h = height ?? isMobile ? 32 : 48;
  if (logo) {
    return (
      <HImage
        src={logo.url}
        width={logo?.width || w}
        height={logo?.height || h}
      />
    );
  }
  return (
    <svg
      width="178"
      height="28"
      viewBox="0 0 178 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1084_5042)">
        <path
          d="M29.5391 20.6958V9.56177H33.5456V19.5011C33.5456 22.2156 34.9028 23.7759 37.2922 23.7759C39.6083 23.7759 41.2337 22.1505 41.2337 19.4361V9.56177H45.2484V27.0593H41.2418V24.3448C40.1122 26.0027 38.4949 27.425 35.7724 27.425C31.8227 27.425 29.5391 24.7756 29.5391 20.6958Z"
          fill="#001A71"
        />
        <path
          d="M47.8633 3.06055H52.1706V6.87212H47.8633V3.06055ZM48.0339 9.56217H52.0405V27.0597H48.0339V9.56217Z"
          fill="#001A71"
        />
        <path
          d="M53.832 18.4123V18.3473C53.832 13.3736 57.6761 9.19629 62.9098 9.19629C66.2256 9.19629 68.2817 10.4235 69.9071 12.2114L67.4203 14.8933C66.1931 13.6011 64.9009 12.7072 62.8773 12.7072C59.9597 12.7072 57.8386 15.2265 57.8386 18.2742V18.3392C57.8386 21.4518 59.9922 23.9712 63.0724 23.9712C64.9578 23.9712 66.3556 23.0773 67.6153 21.7851L70.0371 24.1744C68.3142 26.1005 66.2906 27.4577 62.8773 27.4577C57.6761 27.4577 53.832 23.378 53.832 18.4123Z"
          fill="#001A71"
        />
        <path
          d="M71.2305 2.86523H75.237V17.3151L82.4944 9.56191H87.3706L80.4139 16.6893L87.6062 27.0594H82.9658L77.6995 19.5013L75.2452 22.0532V27.0594H71.2386V2.86523H71.2305Z"
          fill="#001A71"
        />
        <path
          d="M89.2266 23.8427L97.2235 17.0404C100.409 14.3503 101.571 12.8631 101.571 10.7663C101.571 8.47447 99.946 7.14977 97.8249 7.14977C95.7037 7.14977 94.2409 8.31193 92.453 10.6363L89.5679 8.37695C91.7947 5.25617 93.9808 3.50073 98.1256 3.50073C102.669 3.50073 105.789 6.2883 105.789 10.4331V10.4981C105.789 14.1471 103.863 16.1383 99.7509 19.4866L94.9723 23.4688H106.017V27.0529H89.2266V23.8427Z"
          fill="#00B2FF"
        />
        <path
          d="M107.406 15.5128V15.4478C107.406 8.84864 112.347 3.43604 119.385 3.43604C123.668 3.43604 126.253 4.93141 128.479 7.05256L125.854 10.0677C123.993 8.34476 122.002 7.1826 119.353 7.1826C114.907 7.1826 111.689 10.8316 111.689 15.3746V15.4397C111.689 19.9827 114.907 23.7048 119.353 23.7048C122.205 23.7048 124.034 22.5427 126.025 20.6897L128.65 23.3473C126.228 25.8666 123.571 27.4595 119.231 27.4595C112.453 27.4595 107.406 22.177 107.406 15.5128Z"
          fill="#00B2FF"
        />
        <path
          d="M141.183 27.0617V24.908C139.989 26.3384 138.16 27.4274 135.511 27.4274C132.195 27.4274 129.277 25.5338 129.277 22.0229V21.9579C129.277 18.0732 132.292 16.2202 136.38 16.2202C138.501 16.2202 139.867 16.5209 141.224 16.9516V16.6184C141.224 14.1966 139.696 12.8719 136.909 12.8719C134.95 12.8719 133.495 13.3026 131.902 13.969L130.805 10.7507C132.731 9.88924 134.617 9.28784 137.477 9.28784C142.654 9.28784 145.174 12.0104 145.174 16.6834V27.0698H141.183V27.0617ZM141.281 19.7229C140.249 19.3247 138.826 19.024 137.266 19.024C134.747 19.024 133.251 20.0562 133.251 21.7466V21.8116C133.251 23.4695 134.747 24.396 136.632 24.396C139.29 24.396 141.281 22.9006 141.281 20.7144V19.7229Z"
          fill="#00B2FF"
        />
        <path
          d="M146.523 24.7698L148.311 22.0472C150.205 23.4776 152.261 24.2009 154.049 24.2009C155.772 24.2009 156.772 23.4694 156.772 22.3073V22.2423C156.772 20.885 154.91 20.4137 152.854 19.7879C150.27 19.0565 147.377 18 147.377 14.6435V14.5785C147.377 11.2626 150.132 9.23901 153.618 9.23901C155.804 9.23901 158.194 10.003 160.055 11.2301L158.462 14.0827C156.772 13.0506 154.975 12.4248 153.521 12.4248C151.96 12.4248 151.066 13.1562 151.066 14.1802V14.2453C151.066 15.505 152.96 16.0332 155.016 16.6996C157.568 17.4961 160.461 18.6582 160.461 21.8115V21.8765C160.461 25.5581 157.609 27.3867 153.96 27.3867C151.465 27.3867 148.71 26.4927 146.523 24.7698Z"
          fill="#00B2FF"
        />
        <path
          d="M162.281 2.83472H166.296V12.2539C167.426 10.596 169.051 9.16567 171.774 9.16567C175.723 9.16567 178.007 11.8232 178.007 15.903V27.0533H173.992V17.1058C173.992 14.3832 172.635 12.8228 170.246 12.8228C167.921 12.8228 166.296 14.4482 166.296 17.1708V27.0614H162.281V2.83472Z"
          fill="#00B2FF"
        />
        <path
          d="M14.4295 22.3873C14.1126 22.4198 13.7875 22.4442 13.4624 22.4442C8.58626 22.4442 4.61219 18.4782 4.61219 13.5939C4.61219 8.70952 8.57814 4.75165 13.4624 4.75165C18.3467 4.75165 22.3127 8.71764 22.3127 13.602C22.3127 15.2274 21.8738 16.7471 21.1017 18.0556L24.0274 21.9403C25.8397 19.6485 26.9206 16.7553 26.9206 13.602C26.9206 6.16576 20.8904 0.135498 13.4543 0.135498C6.01815 0.135498 -0.00390625 6.16576 -0.00390625 13.602C-0.00390625 21.0382 6.02628 27.0685 13.4624 27.0685C15.5348 27.0685 17.5015 26.5971 19.2488 25.76L14.4295 22.3873Z"
          fill="#001A71"
        />
        <path
          d="M16.9148 16.5517H19.9949L16.0777 11.3423H8.11328L14.7611 16.5517H9.9581L26.1713 27.8645L16.9148 16.5517Z"
          fill="#00B2FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1084_5042">
          <rect
            width="178.007"
            height="27.729"
            fill="white"
            transform="translate(-0.00390625 0.135498)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
